import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const images = [];
  for (let i = 1; i <= 11; i++) {
    images.push(`${process.env.PUBLIC_URL}/images/img${i}.jpeg`);
  }

  // 🎥 Videos Array (3 videos)
  const videos = [
    `${process.env.PUBLIC_URL}/images/video1.mp4`,
    `${process.env.PUBLIC_URL}/images/video2.mp4`,
    `${process.env.PUBLIC_URL}/images/video3.mp4`,
     `${process.env.PUBLIC_URL}/images/video4.mp4`,
  ];

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupImages, setPopupImages] = useState([]);
  const [popupVideos, setPopupVideos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVideo, setIsVideo] = useState(false);

  const openImagePopup = (imgs, index) => {
    setPopupImages(imgs);
    setCurrentIndex(index);
    setIsVideo(false);
    setPopupOpen(true);
  };

  const openVideoPopup = (vids, index) => {
    setPopupVideos(vids);
    setCurrentIndex(index);
    setIsVideo(true);
    setPopupOpen(true);
  };

  const closePopup = () => setPopupOpen(false);

  const prevItem = () =>
    setCurrentIndex((prev) =>
      prev === 0
        ? (isVideo ? popupVideos.length : popupImages.length) - 1
        : prev - 1
    );

  const nextItem = () =>
    setCurrentIndex((prev) =>
      prev ===
      (isVideo ? popupVideos.length : popupImages.length) - 1
        ? 0
        : prev + 1
    );

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

      {/* 🎥 Video Button */}
      <div className="certificate-btn-box">
        <button
          className="certificate-btn"
          onClick={() => openVideoPopup(videos, 0)}
        >
          🎥 व्हिडिओ पहा
        </button>
      </div>

      {/* Main Gallery */}
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div
            className="gallery-card"
            key={index}
            onClick={() => openImagePopup(images, index)}
          >
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {popupOpen && (
        <div className="popup-overlay">
          <span className="close-btn" onClick={closePopup}>
            ✕
          </span>

          <span className="nav-btn left" onClick={prevItem}>
            ❮
          </span>

          {isVideo ? (
            <video
              src={popupVideos[currentIndex]}
              controls
              autoPlay
              className="popup-img"
            />
          ) : (
            <img
              src={popupImages[currentIndex]}
              alt="popup"
              className="popup-img"
            />
          )}

          <span className="nav-btn right" onClick={nextItem}>
            ❯
          </span>
        </div>
      )}
    </div>
  );
};

export default Gallery;